import { observer } from 'mobx-react';
import ImageWrapper from './ImageWrapper';
import ImageReplaceDelete from './ImageReplaceDelete';
import UploadSection from './UploadSection';
import { UploadImageStore } from '../UploadImageStore';
import { Link } from '../../../../../../../Resource/Types';
import { Maybe } from 'maybeasy';
import { handleImageChange } from './Types';

interface Props {
  store: UploadImageStore;
  uploadLink: Link;
  previewUrl: Maybe<Link>;
  setPreviewUrl: (url: Maybe<Link>) => void;
}

function UploadImage({ previewUrl, setPreviewUrl, store, uploadLink }: Props) {
  return (
    <>
      <ImageWrapper>
        <input
          type="file"
          accept="image/png, image/jpeg, image/gif"
          id="upload-button"
          className="hidden"
          data-intercom-target="organization-logo-file-input"
          onChange={handleImageChange(store, uploadLink, previewUrl, setPreviewUrl)}
        />
        <UploadSection previewUrl={previewUrl} />
      </ImageWrapper>
      <ImageReplaceDelete previewUrl={previewUrl} setPreviewUrl={setPreviewUrl} store={store} />
    </>
  );
}

export default observer(UploadImage);
